import { RootState } from '@/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MixpanelManager } from './mixpanelManager';
import { TrackingManager } from './trackingManager';

export const useMixpanel = () => {
  const user = useSelector((store: RootState) => store.user);
  const org = useSelector((store: RootState) => store.org);
  const [userLoaded, setUserLoaded] = useState(false);

  useEffect(() => {
    MixpanelManager.init();
  }, []);

  useEffect(() => {
    if (!userLoaded && user?.userId && user?.email && user?.displayName && org?.name) {
      MixpanelManager.registerMixpanel({
        userId: user.userId,
        displayName: user.displayName,
        email: user.email,
        org: org.name,
        permission: user.permission,
        phoneNumber: user.phoneNumber,
        title: user.title,
        role: user.role,
      });
      // Load user stats once per session and push to Mixpanel/Gleap
      TrackingManager.loadUserStatsOnce();
      setUserLoaded(true);
    }
  }, [user, org, userLoaded]);

  return {};
};
